// extracted by mini-css-extract-plugin
module.exports = {"noStretch":"columns_noStretch__F8xl5","col2Stretch":"columns_col2Stretch__hPhVF","col3Stretch":"columns_col3Stretch__Mt8_H","col4Stretch":"columns_col4Stretch__nRWk1"};